module.exports = __webpack_public_path__ + "static/media/syndra.c188d959.png";